<template>
  <svg 
    :width="width" 
    :height="height" 
    viewBox="0 0 26 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="livro-estrela-icon"
  >
    <path 
      d="M19.7245 7.71314L17.6313 13.8115L16.1211 11.5889L13.5657 12.416L15.6589 6.31763" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M7.58117 16.6107C7.71996 16.2063 8.0137 15.8737 8.39776 15.6859C8.78181 15.4981 9.22473 15.4706 9.62908 15.6094L18.2684 18.5749L21.7572 8.41089L13.1179 5.44544C12.7135 5.30664 12.2706 5.33416 11.8865 5.52194C11.5025 5.70971 11.2087 6.04237 11.0699 6.44671L7.58117 16.6107Z" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M7.5813 16.6108L7.40686 17.119L16.5544 20.2589" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M1.63505 2.7959C1.71611 2.46161 2.19154 2.46161 2.2726 2.7959L2.49565 3.71572C2.52459 3.83507 2.61777 3.92825 2.73712 3.95719L3.65694 4.18024C3.99123 4.2613 3.99123 4.73673 3.65694 4.81779L2.73712 5.04083C2.7222 5.04445 2.70769 5.04907 2.69367 5.05462C2.59548 5.09348 2.52097 5.17788 2.49565 5.28231L2.2726 6.20212C2.26754 6.22302 2.26093 6.2426 2.25298 6.26088C2.13366 6.53511 1.71104 6.51552 1.63505 6.20212L1.41201 5.28231C1.4102 5.27485 1.40814 5.26749 1.40584 5.26025C1.37132 5.15156 1.28242 5.06796 1.17053 5.04083L0.250716 4.81779C0.229823 4.81272 0.210236 4.80612 0.191954 4.79816C-0.0822661 4.67884 -0.0626791 4.25623 0.250716 4.18024L1.17053 3.95719C1.28988 3.92825 1.38307 3.83507 1.41201 3.71572L1.63505 2.7959Z" 
      :fill="color"
    />
    <path 
      d="M6.42384 7.04253C6.42384 7.47417 6.07394 7.82407 5.64231 7.82407C5.21068 7.82407 4.86078 7.47417 4.86078 7.04253C4.86078 6.6109 5.21068 6.26099 5.64231 6.26099C6.07394 6.26099 6.42384 6.6109 6.42384 7.04253Z" 
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'LivroEstrelaIcon',
  props: {
    color: {
      type: String,
      default: '#4B089F'
    },
    width: {
      type: [String, Number],
      default: 24
    },
    height: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>

<style scoped>
.livro-estrela-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
